// This file is auto-generated by localize-js, do not make edits to this file directly
import { TranslatedStringTableFetcher, getStringProvider } from '@fluidx/localize-js';

export interface DiscoverStrings {
  loading: string;
  noResult: string;
  search: string;
  searchBoxAriaLabel: string;
  discoverMenuAriaLabel: string;
  discoverMenuListLabel: string;
}

export async function getDiscoverStrings(translatedStringTableFetcher: TranslatedStringTableFetcher, locale: string): Promise<DiscoverStrings> {
  const stringTableJson = await translatedStringTableFetcher(locale);
  return getStringProvider<DiscoverStrings>(stringTableJson, locale);
}
